import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "m13.9 20.4 5.9-1.9c-.1-.1-.2-.3-.4-.4s-.2-.1-.4-.1h-6.2c-.3 0-.5-.1-.8-.2l-1.4-.5c-.3-.1-.5-.2-.6-.5s-.1-.5 0-.8.2-.5.5-.6.5-.1.8-.1l1.1.4c.3.1.6.1 1 .2s.8.1 1.5.1h.1c0-.2-.1-.4-.2-.5-.1-.2-.2-.3-.4-.3L8.6 13H7v5.5zm-.5 2L7 20.5c-.1.4-.4.8-.8 1.1s-.8.4-1.2.4H3c-.5 0-1-.2-1.4-.6S1 20.5 1 20v-7c0-.6.2-1 .6-1.4S2.5 11 3 11h5.9c.1 0 .2.1.3.1l5.9 2.2c.5.2 1 .5 1.3 1s.6 1.1.6 1.7h2c.8 0 1.5.3 2.1.8s.9 1.3.9 2.2q0 .6-.3.9c-.2.2-.5.4-.9.5l-6.3 2c-.2.1-.4.1-.6.1s-.3-.1-.5-.1M3 20h2v-7H3zM13.2 8.5h-2.5c-.3 0-.5-.1-.7-.3s-.3-.4-.3-.7.1-.5.3-.7.4-.3.7-.3h2.5V4c0-.3.1-.5.3-.7s.4-.3.7-.3.5.1.7.3.3.4.3.7v2.5h2.5c.3 0 .5.1.7.3s.3.4.3.7-.1.5-.3.7-.4.3-.7.3h-2.5V11c0 .3-.1.5-.3.7s-.4.3-.7.3-.5-.1-.7-.3-.3-.4-.3-.7z" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }